import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import Style from '../assets/css/languages.module.css'

const Languages = () => {

    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const iconRef = useRef(null);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('i18nextLng', lang);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !iconRef.current.contains(event.target)) {
                setIsOpen(false); // Cierra el menú
            }
        };

        // Agregar el event listener cuando el componente se monte
        document.addEventListener('mousedown', handleClickOutside);

        // Limpiar el event listener cuando el componente se desmonte
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className={Style.languageSwitch}>
                <div className={Style.iconContainer} onClick={() => setIsOpen(!isOpen)} ref={iconRef}>
                    <FontAwesomeIcon icon={faGlobe} size="2x" />
                </div>
                {isOpen && (
                    <div className={Style.languageMenu} ref={menuRef}>
                        <button onClick={() => changeLanguage('en')}>English</button>
                        <button onClick={() => changeLanguage('es')}>Español</button>
                        <button onClick={() => changeLanguage('fr')}>Français</button>
                        <button onClick={() => changeLanguage('zh')}>中文</button>
                        <button onClick={() => changeLanguage('de')}>Deutsch</button>
                    </div>
                )}
            </div>
        </>
    )
}

export default Languages
